import { createApp } from 'vue'
import pinia from './store'
import router from './router'
import './style.css'
import App from './App.vue'
const app = createApp(App)
app.use(router)
app.use(pinia)

// 挂载应用
app.mount('#app')
